<template>
  <div id="modalMenuImg">
    <div :style="`background-image: url('${img}');`" class="img">
      <div class="container_icon">
        <i @click="$parent.close()" aria-hidden="true" class="fa fa-times close"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['img']
};
</script>
<style lang="scss">
#modalMenuImg {
  border-radius: 20px;
  background-color: rgba(#000000, 0.5);
  height: 300px;
  position: relative;
  .img {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
  }
  .close {
    font-weight: 900;
    color: white;
    font-size: 25px;
    cursor: pointer;
    margin-right: 15px;
    margin-top: 5px;
  }
  .container_icon {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
